import { render, staticRenderFns } from "./BaseSegmento.vue?vue&type=template&id=8d123c4e&scoped=true&"
import script from "./BaseSegmento.vue?vue&type=script&lang=js&"
export * from "./BaseSegmento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d123c4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
